export {
  MainContainer,
  PageBody,
  FlexColumn,
  FlexColumnContainer,
  ColumnLayout,
  HeaderColumnLayout,
} from './DrilldownStyle';

export { default as DrilldownItem } from '@components/DrilldownItem';
export { default as Attachments } from '@components/Attachments';
